<template>
  <div v-html="agreementInfo">
    
  </div>
</template>

<script setup lang="ts">
  import { reactive, ref, onMounted, getCurrentInstance,computed } from 'vue';
  import logger from '@utils/logger';
  import { agreementInfoApi } from '@/api/agreement';
  import { parseQuery } from '@utils/utils';
	const { proxy } = getCurrentInstance() as any

  const query = parseQuery()
  const agreementInfo = ref<any>('')
  const getAgreementInfo = async () => {
    try {
      const res = await agreementInfoApi({
        agreementId: query?.id || ''
      })
      if(res?.code === 0) {
        agreementInfo.value = res?.data?.content || ''
      }
    } catch (error) {
      console.log('获取协议内容error:', error)
    }
  }
  onMounted(() => {
    getAgreementInfo()
  })

  logger.info('App.vue mounted')  
</script>